var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "28px",
    viewBox: "0 0 31 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plane-send") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plane-send",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8421663,0.11223092 C30.7041725,-0.00588892 30.507793,-0.03329345 30.3413478,0.04204639 L0.26813799,13.6784666 C0.10623383,13.7519071 0.00197386,13.909551 2.768e-05,14.0837461 C-0.00191851,14.2579412 0.09891247,14.4177557 0.25924114,14.4945427 L6.6071225,17.1706721 C6.7631881,17.2454693 6.9492805,17.2285562 7.0886645,17.1268972 L22.572687,6.8912084 L11.0301767,19.0122196 C10.9375012,19.1052865 10.8902366,19.2327221 10.9004309,19.362057 L11.5472135,27.5824201 C11.5615782,27.7645743 11.6866902,27.9203189 11.8645345,27.977389 C11.912077,27.9925836 11.960917,28 12.009201,28 C12.1416343,28 12.2704533,27.9445578 12.3600706,27.8432606 L16.8772613,22.7348035 L22.4614254,25.3386858 C22.582645,25.3952133 22.7229557,25.3975648 22.8461215,25.3452882 C22.9692873,25.2929211 23.0630749,25.1910812 23.1032961,25.0660876 L30.9786774,0.58769494 C31.0337267,0.41675581 30.9800675,0.23035076 30.8421663,0.11223092 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneSend);
export default __webpack_public_path__ + "static/media/plane-send.34857b66437f86d298035c186ad22ea8.svg";
export { ForwardRef as ReactComponent };